const map = {
	"./shared/benchmarks/benchmark-percentile-chart/index.js": [
		89994,
		[
			2528,
			1284,
			2316,
			9994
		]
	],
	"./shared/benchmarks/benchmarks-list/index.js": [
		53522,
		[
			9690,
			2528,
			2316,
			3522
		]
	],
	"./shared/benchmarks/benchmarks-selector/index.js": [
		49526,
		[
			2528,
			1284,
			2316,
			7621,
			9526
		]
	],
	"./shared/benchmarks/config/index.js": [
		24249,
		[
			1284,
			4249
		]
	],
	"./shared/benchmarks/hooks/index.js": [
		57162,
		[
			7162
		]
	],
	"./shared/benchmarks/screens/index.js": [
		16836,
		[
			1284,
			6836
		]
	],
	"./shared/benchmarks/simple-store/index.js": [
		40077,
		[
			77
		]
	],
	"./shared/copy-to-clipboard/index.js": [
		5995,
		[
			2316,
			5995
		]
	],
	"./views/index.js": [
		23769,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86864;
module.exports = webpackAsyncContext;